export default {
  sm: `
  DATA CENTER GAK
  THAT HOLDS
  THE FUTURES
  `,
  md: `
  DATA CENTER GAK
  THAT HOLDS
  THE FUTURES
  `,
};
